import { type BaseSyntheticEvent, type ReactNode } from 'react';


import type { UseFormReturn } from 'react-hook-form';

import { FormRootError } from '@/components/form/formRootError';
import StatusMessage from '@/components/statusMessage';
import { Button } from '@/components/ui/button';
import { Form } from '@/components/ui/form';

import type { CreateSandbox } from '../models/createSandbox';

interface SandboxFormProps {
  form: UseFormReturn<CreateSandbox>;
  handleSubmit: (
    callback: (data: CreateSandbox) => Promise<void>,
  ) => (e?: BaseSyntheticEvent) => Promise<void>;
  isSubmitting: boolean;
  submit: (data: CreateSandbox) => Promise<void>;
  close: (close: boolean) => void;
  children: ReactNode;
  title?: string;
}

export const SandboxForm = ({
  form,
  handleSubmit,
  isSubmitting,
  submit,
  close,
  children,
  title = 'Sandbox',
}: SandboxFormProps) => {
  return (
    <>
      {isSubmitting && (
        <StatusMessage
          type="info"
          title={`Creating ${title}`}
          message={`Please wait while we create your ${title.toLowerCase()}...`}
        />
      )}
      <Form {...form}>
        <FormRootError />
        <form onSubmit={handleSubmit(submit)} className="nacon-form">
          {children}
          <div className="flex justify-end bg-background">
            <Button
              type="button"
              variant="outline"
              onClick={() => {
                close(true);
              }}
            >
              Cancel
            </Button>
            <Button type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'Saving...' : 'Create'}
            </Button>
          </div>
        </form>
      </Form>
    </>
  );
};
